import { ACTIVE_USERS_LIST_TAG } from '../constants';
import { api } from '../core';
import { UserRoleType } from './userAbout';

export type UserEditResponse = null;

export type UserEditProps = { userToEditId: string } & Partial<{
  firstName: string;
  lastName: string;
  emailAddress: string;
  role: UserRoleType;
}>;

const userEditApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postUserEdit: builder.query<UserEditResponse, UserEditProps>({
      query: (props: UserEditProps) => {
        // Only include defined properties in the body
        const body: Record<string, unknown> = {};
        Object.entries(props).forEach(([key, value]) => {
          if (value !== undefined) {
            body[key] = value;
          }
        });

        return {
          url: 'user/edit',
          method: 'POST',
          body: body
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(api.util.invalidateTags([ACTIVE_USERS_LIST_TAG]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postUserEdit in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostUserEditQuery } = userEditApi;
